import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import useStyles from './style';

/**
 * @name ActionCTA - Generic CTA component
 * @param {Array} props - CTA data from Strapi
 * @returns {JSX.Element} - CTA's component
 */
const ActionCTA = props => {
  const theme = useTheme();
  const style = useStyles(theme);

  /**
   * @param {object} stylesMap - Returns style object
   */
  const stylesMap = {
    text: style.text,
    outlined: style.outlined,
    contained: style.contained,
  };
  return (
    <Box sx={style.ctaContainer}>
      {props?.cta && props?.cta?.length > 0 && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 2, sm: 2, md: 2 }}
          justifyContent={{ xs: 'center', sm: 'flex-start' }}
        >
          {props?.cta?.map((item, index) => (
            <Button
              key={index}
              onClick={() => props.handleAction(item?.action, item?.url)}
              type={item.type}
              disabled={props.disablecta || item.disable}
              variant='buttonMedium'
              aria-label='Quick Top-up'
              sx={stylesMap[item.type] ?? style.contained}
            >
              {item.name}
            </Button>
          ))}
        </Stack>
      )}
    </Box>
  );
};

ActionCTA.displayName = 'ActionCTA';
export default ActionCTA;
